var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":""}},[(_vm.error.statusCode === 404)?_c('h1',[_vm._v("\n\t\t"+_vm._s(_vm.pageNotFound)+"\n\t")]):_c('h1',[_vm._v("\n\t\t"+_vm._s(_vm.otherError)+"\n\t")]),_vm._v(" "),_c('NuxtLink',{attrs:{"to":"/"}},[_vm._v(" Home page ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }